import { CustomLink } from "@/components/CustomLink.tsx";
import styles from "../SitemapModule.module.scss";
import { SitemapGroup } from "@/getData/getSitemapData.ts";

interface SitemapSectionProps {
  group: SitemapGroup;
}

export const SitemapSection = ({ group }: SitemapSectionProps) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{group.label}</h3>
      <div className={styles.grid}>
        {group.items.map((item, index) => (
          <div key={index}>
            <CustomLink href={item.link} target={"_self"}>
              <span dangerouslySetInnerHTML={{ __html: item.title }} />
            </CustomLink>
          </div>
        ))}
      </div>
    </div>
  );
};
